if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');
      
      // Check if inline format (promo strip style - shows total hours with padding)
      this.isInline = this.dataset.inline === 'true';

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }

    timer() {
      // Get current time in UK timezone (Europe/London)
      const ukNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
      const timeDiff = this.endDate - ukNow;

      if (timeDiff < 0) {
        clearInterval(this.interval);
        if (this.isInline) {
          this.style.display = 'none';
        }
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      const displayHours = hours - days * 24;
      const displayMins = mins - hours * 60;
      const displaySecs = secs - mins * 60;

      if (this.isInline) {
        // Inline format: total hours (days * 24 + hours) with zero-padding
        const totalHours = days * 24 + displayHours;
        if (this.daysEl) this.daysEl.textContent = days;
        this.hoursEl.textContent = this.pad(totalHours);
        this.minsEl.textContent = this.pad(displayMins);
        this.secsEl.textContent = this.pad(displaySecs);
      } else {
        // Standard boxed format
        this.daysEl.textContent = days;
        this.hoursEl.textContent = displayHours;
        this.minsEl.textContent = displayMins;
        this.secsEl.textContent = displaySecs;
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
